// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.av2-root {
    padding: 16px;
    padding-top: 50px;
    background: #f5f6fa;
    min-height: 100vh;
}

/* ── Tabs ─────────────────────────────────────────────── */
.av2-tabs-bar {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.07);
    margin-bottom: 12px;
    padding: 0 8px;
}

/* ── Filter bar ───────────────────────────────────────── */
.av2-filter-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.07);
    padding: 12px 16px;
    margin-bottom: 16px;
}

.av2-filter {
    min-width: 150px !important;
    background: #fff;
}

.av2-run-btn {
    background-color: #f47803 !important;
    color: #fff !important;
    text-transform: none !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    padding: 7px 24px !important;
    white-space: nowrap;
    box-shadow: 0 2px 8px rgba(244,120,3,0.3) !important;
}
.av2-run-btn:hover   { background-color: #d86602 !important; }
.av2-run-btn:disabled { background-color: #e0e0e0 !important; color: #aaa !important; box-shadow: none !important; }

/* ── Chart area wrapper ───────────────────────────────── */
.av2-chart-area {
    min-height: 200px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
}
.av2-chart-area > .MuiBox-root { width: 100%; }
.av2-chart-area > p            { align-self: center; margin-top: 120px; }

/* ── Individual chart card ────────────────────────────── */
.av2-chart-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.06);
    overflow: hidden;
    padding: 4px 4px 0 4px;
}

/* ── Mini charts grid (responsive) ───────────────────── */
.av2-mini-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
}

@media (max-width: 1200px) {
    .av2-mini-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 768px) {
    .av2-mini-grid { grid-template-columns: 1fr; }
    .av2-filter    { min-width: 130px !important; }
}

/* ── Loading ──────────────────────────────────────────── */
.av2-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;
    width: 100%;
}

/* ── Toolbar download menu ───────────────────────────── */
.apexcharts-menu {
    min-width: 150px !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 16px rgba(0,0,0,0.12) !important;
}
.apexcharts-menu-item {
    white-space: nowrap !important;
    padding: 8px 16px !important;
    font-size: 13px !important;
}
.apexcharts-menu-item:hover {
    background: #f5f6fa !important;
}

/* ── Suppress ApexCharts overflow/scroll ─────────────── */
.av2-chart-card .apexcharts-canvas {
    overflow: hidden !important;
    max-width: 100% !important;
}
.av2-chart-card .apexcharts-canvas svg {
    overflow: hidden !important;
    max-width: 100% !important;
}
.av2-chart-card .apexcharts-inner {
    overflow: hidden !important;
}

/* ── Cursor: default on chart, pointer on bar areas ─────────── */
.av2-chart-card .apexcharts-canvas,
.av2-chart-card .apexcharts-canvas *,
.av2-chart-card .apexcharts-svg,
.av2-chart-card .apexcharts-inner,
.av2-chart-card .apexcharts-graphical,
.av2-chart-card .apexcharts-line-area,
.av2-chart-card rect.apexcharts-zoom-rect {
    cursor: default !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/Pages/Analytics-V2/AnalyticsV2.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,4DAA4D;AAC5D;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;IACtC,mBAAmB;IACnB,cAAc;AAClB;;AAEA,4DAA4D;AAC5D;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;IACtC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,+BAA+B;IAC/B,2BAA2B;IAC3B,6BAA6B;IAC7B,4BAA4B;IAC5B,mBAAmB;IACnB,oDAAoD;AACxD;AACA,uBAAuB,oCAAoC,EAAE;AAC7D,wBAAwB,oCAAoC,EAAE,sBAAsB,EAAE,2BAA2B,EAAE;;AAEnH,4DAA4D;AAC5D;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;AACA,iCAAiC,WAAW,EAAE;AAC9C,iCAAiC,kBAAkB,EAAE,iBAAiB,EAAE;;AAExE,4DAA4D;AAC5D;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,2DAA2D;AAC3D;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,iBAAiB,qCAAqC,EAAE;AAC5D;;AAEA;IACI,iBAAiB,0BAA0B,EAAE;IAC7C,iBAAiB,2BAA2B,EAAE;AAClD;;AAEA,4DAA4D;AAC5D;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;AACf;;AAEA,2DAA2D;AAC3D;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,kDAAkD;AACtD;AACA;IACI,8BAA8B;IAC9B,4BAA4B;IAC5B,0BAA0B;AAC9B;AACA;IACI,8BAA8B;AAClC;;AAEA,2DAA2D;AAC3D;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;AACA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;AACA;IACI,2BAA2B;AAC/B;;AAEA,kEAAkE;AAClE;;;;;;;IAOI,0BAA0B;AAC9B","sourcesContent":[".av2-root {\n    padding: 16px;\n    padding-top: 50px;\n    background: #f5f6fa;\n    min-height: 100vh;\n}\n\n/* ── Tabs ─────────────────────────────────────────────── */\n.av2-tabs-bar {\n    background: #fff;\n    border-radius: 10px;\n    box-shadow: 0 1px 4px rgba(0,0,0,0.07);\n    margin-bottom: 12px;\n    padding: 0 8px;\n}\n\n/* ── Filter bar ───────────────────────────────────────── */\n.av2-filter-bar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n    background: #fff;\n    border-radius: 10px;\n    box-shadow: 0 1px 4px rgba(0,0,0,0.07);\n    padding: 12px 16px;\n    margin-bottom: 16px;\n}\n\n.av2-filter {\n    min-width: 150px !important;\n    background: #fff;\n}\n\n.av2-run-btn {\n    background-color: #f47803 !important;\n    color: #fff !important;\n    text-transform: none !important;\n    font-weight: 600 !important;\n    border-radius: 8px !important;\n    padding: 7px 24px !important;\n    white-space: nowrap;\n    box-shadow: 0 2px 8px rgba(244,120,3,0.3) !important;\n}\n.av2-run-btn:hover   { background-color: #d86602 !important; }\n.av2-run-btn:disabled { background-color: #e0e0e0 !important; color: #aaa !important; box-shadow: none !important; }\n\n/* ── Chart area wrapper ───────────────────────────────── */\n.av2-chart-area {\n    min-height: 200px;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n.av2-chart-area > .MuiBox-root { width: 100%; }\n.av2-chart-area > p            { align-self: center; margin-top: 120px; }\n\n/* ── Individual chart card ────────────────────────────── */\n.av2-chart-card {\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.06);\n    overflow: hidden;\n    padding: 4px 4px 0 4px;\n}\n\n/* ── Mini charts grid (responsive) ───────────────────── */\n.av2-mini-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 16px;\n}\n\n@media (max-width: 1200px) {\n    .av2-mini-grid { grid-template-columns: repeat(2, 1fr); }\n}\n\n@media (max-width: 768px) {\n    .av2-mini-grid { grid-template-columns: 1fr; }\n    .av2-filter    { min-width: 130px !important; }\n}\n\n/* ── Loading ──────────────────────────────────────────── */\n.av2-loading {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 300px;\n    width: 100%;\n}\n\n/* ── Toolbar download menu ───────────────────────────── */\n.apexcharts-menu {\n    min-width: 150px !important;\n    border-radius: 8px !important;\n    box-shadow: 0 4px 16px rgba(0,0,0,0.12) !important;\n}\n.apexcharts-menu-item {\n    white-space: nowrap !important;\n    padding: 8px 16px !important;\n    font-size: 13px !important;\n}\n.apexcharts-menu-item:hover {\n    background: #f5f6fa !important;\n}\n\n/* ── Suppress ApexCharts overflow/scroll ─────────────── */\n.av2-chart-card .apexcharts-canvas {\n    overflow: hidden !important;\n    max-width: 100% !important;\n}\n.av2-chart-card .apexcharts-canvas svg {\n    overflow: hidden !important;\n    max-width: 100% !important;\n}\n.av2-chart-card .apexcharts-inner {\n    overflow: hidden !important;\n}\n\n/* ── Cursor: default on chart, pointer on bar areas ─────────── */\n.av2-chart-card .apexcharts-canvas,\n.av2-chart-card .apexcharts-canvas *,\n.av2-chart-card .apexcharts-svg,\n.av2-chart-card .apexcharts-inner,\n.av2-chart-card .apexcharts-graphical,\n.av2-chart-card .apexcharts-line-area,\n.av2-chart-card rect.apexcharts-zoom-rect {\n    cursor: default !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
